import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconEdit, IconSettings } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

import { InstPage, Platform, TgPage } from '../../../types';

import { ArchiveButton } from './Buttons/ArchiveButton';
import { ConnectButton } from './Buttons/ConnectButton';
import { EditPageModal } from './Buttons/EditPageModal';
import { ImportButton } from './Buttons/ImportButton';
import { NotificationButton } from './Buttons/NotificationButton';
import { QrConnectButton } from './Buttons/QrConnectButton';
import { RealTimeStatsButton } from './Buttons/RealTimeStatsButton';
import { RemoveButton } from './Buttons/RemoveButton';

import config from '@/config';

type ControlsPanelProps = {
  page: TgPage | InstPage;
  platform: Platform;
};

export const ControlsPanel = ({ page, platform }: ControlsPanelProps) => {
  const navigate = useNavigate();

  function handleEditPage(platform: Platform, page: TgPage | InstPage) {
    if (['telegram', 'instagram'].includes(platform)) {
      NiceModal.show(EditPageModal, {
        platform: platform as 'telegram' | 'instagram',
        page: page as TgPage | InstPage,
      });
    }
  }

  return (
    <Group gap="xs">
      <ActionIcon variant="filled" onClick={() => handleEditPage(platform, page)} radius="md">
        <Tooltip label="Edit Page Info">
          <IconEdit />
        </Tooltip>
      </ActionIcon>
      <ActionIcon
        variant="filled"
        onClick={() => navigate(`/pages/${platform}/${page._id}`)}
        radius="md"
      >
        <Tooltip label="Edit Page Settings">
          <IconSettings />
        </Tooltip>
      </ActionIcon>
      {!(
        ('integration' in page && page.integration === 'umnico') ||
        ('integration' in page && page.integration === 'instagram-connect') ||
        (platform === 'instagram' && !(page as InstPage).integration)
      ) && (
        <ConnectButton
          platform={platform}
          pageId={page._id}
          isConnected={page.config.isConnected}
          isRestoring={page.config.isRestoring}
        />
      )}
      {config.isTgQrAuthEnabled &&
        platform === 'telegram' &&
        !page.config.isConnected &&
        !page.config.isRestoring &&
        !(page as TgPage).botToken && <QrConnectButton pageId={page._id} pageName={page.name} />}
      <ImportButton platform={platform} page={page} />
      <NotificationButton
        platform={platform}
        isHotDialogNotificationEnabled={
          'isHotDialogNotificationEnabled' in page.config &&
          page.config.isHotDialogNotificationEnabled
        }
        pageId={page._id}
      />
      <RealTimeStatsButton
        platform={platform}
        isRealTimeStatsEnabled={
          'isRealTimeStatsEnabled' in page.config && page.config.isRealTimeStatsEnabled
        }
        pageId={page._id}
      />
      <ArchiveButton
        platform={platform}
        pageId={page._id}
        isArchived={page.config.isArchived}
        isRestoring={page.config.isRestoring}
      />
      <RemoveButton platform={platform} page={page} />
    </Group>
  );
};
